import React, { useEffect, useState } from 'react';
import { useGetFoodQuery } from '../../redux/services/foods/foodAPI ';
import Food from '../../components/Food';

function FoodsList(user) {
  const { data: foods, isLoading, isError, error } = useGetFoodQuery();
  const [filterName, setFilterName] = useState('');
  const [records, setRecords] = useState([]);

  useEffect(() => {
    const filteredFood = (foods || []).filter((food) =>
      food.name.toLowerCase().includes(filterName.toLowerCase())
    );
    setRecords(filteredFood);
  }, [filterName, foods]);

  if (isLoading) {
    return <div className="section-shell py-24 text-center text-muted">Loading menu...</div>;
  }

  if (isError) {
    return <div className="section-shell py-24 text-center text-red-500">Error: {error?.data?.message || error?.message}</div>;
  }

  const visibleFoods = filterName ? records : foods;

  return (
    <section className="bg-surface py-12 sm:py-16">
      <div className="section-shell">
        <div className="mx-auto mb-10 max-w-3xl text-center">
          <span className="eyebrow">Restaurant catalog</span>
          <h1 className="section-title mt-5">Explore every dish</h1>
          <p className="section-copy mx-auto">Search the full restaurant menu with a clean, mobile-first ordering experience.</p>
        </div>

        <div className="premium-card bg-white p-4 sm:p-5">
          <label className="relative block">
            <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-muted">
              <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-4.3-4.3M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" />
              </svg>
            </span>
            <input
              className="field pl-12"
              type="text"
              placeholder="Search dishes, ingredients, or categories"
              value={filterName}
              onChange={(event) => setFilterName(event.target.value)}
            />
          </label>
        </div>

        <div className="mt-8 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {(visibleFoods || []).map((food) => (
            <Food key={food.id} food={food} user={user} condition={false} />
          ))}
        </div>

        {!visibleFoods?.length && (
          <div className="premium-card mt-8 p-10 text-center">
            <p className="text-lg font-bold text-muted">No dishes match your search.</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default FoodsList;
